<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mal-text mt-1 custom-title">Affiliated Centers</h3>
        </div>
    </div>
    <div id="search">
        <form class="search-form">
            <label class="label text-primary" style="margin-bottom:0px;" for="filter_district"><span>District</span></label>
            <div class="form-group searchbox mal-text">
                <select class="form-control custom-select" v-model="filter_district" @change="getCenters()">
                    <option value="">All</option>
                    <option v-for="district in district_list" :key="district.id" :value="district.id">
                        {{ district.name }}
                    </option>
                </select>
                <i class="input-icon">
                    <ion-icon name="filter-outline"></ion-icon>
                </i>
            </div>
        </form>
        <form class="search-form">
            <label class="label text-primary" style="margin-bottom:0px;" for="filter_faculty"><span>Faculty</span></label>
            <div class="form-group searchbox mal-text">
                <select class="form-control custom-select" v-model="filter_faculty" @change="getCenters()">
                    <option value="">All</option>
                    <option value="1">Added</option>
                    <option value="2">Not Added</option>
                </select>
                <i class="input-icon">
                    <ion-icon name="filter-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>
    <div class="section text-center mt-1" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-3" v-if="responseData.centers.total == 0 && !loading">
        <h3 class="text-center mt-2 text-primary">No affiliated centres found</h3>
    </div>
    <div class="section pb-2" v-if="!loading">
        <div class="card pl-2 pr-2 mt-1" v-for="center in responseData.centers.data" :key="center.id">
            <div class="listed-detail mt-1">
                <h3 class="text-center mt-1">{{ center.center_name }}</h3>
            </div>
            <ul class="listview flush transparent simple-listview no-space mt-1">
                <li>
                    <strong>Status</strong>
                    <span class="text-success">{{ center.approve_status }}</span>
                </li>
                <li v-if="center.center_reg_no || center.reg_no">
                    <strong>Registration No</strong>
                    <span class="text-success">{{ center.reg_no || center.center_reg_no }}</span>
                </li>
                <li>
                    <strong>District</strong>
                    <span class="text-primary">{{ center.district ? center.district.name : '' }}</span>
                </li>
                <li>
                    <strong>Level</strong>
                    <span class="text-primary">
                        {{ center.unit && center.unit.name ? center.unit.name : (center.zone ? center.zone.name : '') }}
                        {{ center.user_level == 3 ? 'Zone' : 'Unit' }}
                    </span>
                </li>
                <li>
                    <strong>Class Type</strong>
                    <span class="text-primary">{{ center.class_type || '-' }}</span>
                </li>
                <li>
                    <strong>Faculty</strong>
                    <span class="text-primary" v-if="center.faculty">{{ center.faculty.name }}</span>
                    <span class="text-danger" v-else>Not Added</span>
                </li>
                <li>
                    <strong>Approved By</strong>
                    <span class="text-primary">{{ center.approved_by_name || '-' }}</span>
                </li>
                <li>
                    <strong>Action</strong>
                    <span>
                        <router-link
                            :to="'/org/' + user_level + '/' + user_level_id + '/view-qhls-center/' + center.id"
                            class="text-primary"
                        >
                            View
                        </router-link>
                        &nbsp;|&nbsp;
                        <router-link :to="'/org/qhls/' + center.id" class="text-primary">
                            Dashboard
                        </router-link>
                    </span>
                </li>
            </ul>
        </div>
    </div>
    <div class="section mt-2" v-if="!loading">
        <vue-awesome-paginate
            v-if="responseData.centers.total > 0"
            :total-items="responseData.centers.total"
            :items-per-page="responseData.centers.per_page"
            :max-pages-shown="3"
            v-model="responseData.centers.current_page"
            :on-click="getCenters"
            :show-ending-buttons="true"
            :show-breakpoint-buttons="false"
        />
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: "QHLSAffiliatedCentersList",
    components: {
        AlertModel,
    },
    data() {
        return {
            loading: false,
            alert_type: "",
            alert_message: "",
            user_level: "",
            user_level_id: "",
            filter_district: "",
            filter_faculty: "",
            district_list: [],
            responseData: {
                centers: {
                    data: [],
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                },
                permissions: {},
            },
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        if (parseInt(this.currentUser.user_level, 10) !== 1) {
            this.alert_type = "Warning";
            this.alert_message = "You have no permission!";
            this.$refs.alert_model.openModel();
            return;
        }
        this.user_level = parseInt(this.$route.params.sub_level || this.currentUser.user_level, 10);
        this.user_level_id = parseInt(this.$route.params.id || 0, 10);
        this.$root.updateParent("Affiliated Centers");
        this.getDistrictList();
        this.getCenters();
    },
    methods: {
        getDistrictList() {
            UserService.authPostRequest("get-district-by-id", {}).then(
                (response) => {
                    if (response.data.status === "success") {
                        this.district_list = response.data.data.list;
                    }
                },
                () => {
                    this.district_list = [];
                }
            );
        },
        getCenters(page = 1) {
            this.loading = true;
            const data = {
                user_level_id: this.user_level_id,
                user_level: this.user_level,
                district_id: this.filter_district,
                status: "Approved",
                faculty: this.filter_faculty,
                type: "QHLS",
            };
            UserService.authPostRequest(`get-cre-requests?page=${page}`, data).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status === "success") {
                        this.responseData = response.data.data;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = "Error";
                    this.alert_message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>
